module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "chooseBtn btn tertiary d-flex flex-column",
    class: {
      'border-color-1': !_vm.useExistingAgent
    },
    on: {
      "click": function($event) {
        return _vm.setButton(false)
      }
    }
  }, [_c('span', {
    staticClass: "mb-2 bold"
  }, [_vm._v("New Agent")]), _vm._v(" "), _c('span', {
    staticClass: "fs-smallest"
  }, [_vm._v("Agent not yet in your network")])]), _vm._v(" "), _c('div', {
    staticClass: "chooseBtn btn tertiary d-flex flex-column",
    class: {
      'border-color-1': _vm.useExistingAgent
    },
    on: {
      "click": function($event) {
        return _vm.setButton(true)
      }
    }
  }, [_c('span', {
    staticClass: "mb-2 bold"
  }, [_vm._v("Existing Agent")]), _vm._v(" "), _c('span', {
    staticClass: "fs-smallest"
  }, [_vm._v("Link to an existing offline agent")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5624c376", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5624c376"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentExistingSelector.vue
// module id = 822
// module chunks = 0